import { CSSProperties } from 'react';
import { IconType } from '.';

interface CheckCircleProps extends IconType {
  style?: CSSProperties;
}

export default function CheckCircle({ className = '', color = '#fff', height = 10, style, width = 14 }: CheckCircleProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" className={className}>
      <path
        fill={color}
        d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM14.414,8.164l-5,5a.934.934,0,0,1-1.324,0l-2.5-2.5A.936.936,0,0,1,6.914,9.34L8.75,11.176l4.336-4.34A.936.936,0,0,1,14.41,8.16Z"
      />
    </svg>
  );
}
